/*eslint-disable */
import ViewGroup from './ViewGroup';

export default ViewGroup;
